import { isEmailAddress, getJsonFromCompression, isSameText } from "../utils/helper";
import { checkGraphResponse } from "./GraphMain";
import store from "./StoreRoot";

async function getInfoTables(fileUrl, sessionId, client, helperTables) {
  if (!helperTables) return;
  
  // get the table object
  // if (helperTables === undefined) {
  //   helperTables = await getArTableList(fileUrl, sessionId);
  // }
  // build the batch request
  let requests = [];
  if (helperTables.includes("AR_INFO")) {
    requests.push({
      url: fileUrl + "/workbook/tables/AR_INFO/rows",
      method: "GET",
      id: "INFO",
      headers: {
        "workbook-session-id": sessionId
      }
    })
  }
  if (helperTables.includes("AR_LOG")) {
    requests.push({
      url: fileUrl + "/workbook/tables/AR_LOG/range?$select=rowcount",
      method: "GET",
      id: "LOGRANGE",
      headers: {
        "workbook-session-id": sessionId
      }
    })
  }
  // run the batch
  if (requests.length > 0) {
    const $batch = { requests: requests };
    let res = await client
      .api("/$batch")
      .post($batch);

    checkGraphResponse(res, "getInfoTables");
    return res;
  }
}

export async function getAppInfoFromWorkbook(
  fileUrl: string,
  sessionId: string,
  client: any,
  helperTables: any []
) {
  let changesCount = 0;
  let views = [];
  let ranges = [];
  let calculations = [];
  let documentHeader = undefined;
  let documentFooter = undefined;
  let documentOwner = undefined;
  let documentBackground = undefined;
  let userParameters = undefined;
  let userRoles = ["admin"];
  let batchRes = await getInfoTables(fileUrl, sessionId, client, helperTables);

  if (batchRes) {
    // get the INFO table
    let appInfoTable = batchRes.responses[batchRes.responses.findIndex((x) => x.id === "INFO")];
    if (appInfoTable?.body?.value) {
      try {
        appInfoTable.body.value.forEach((tempValue) => {
          const tempRow = tempValue.values[0];
          const tempType = tempRow[0];
          if (tempType === "document_header") {
            documentHeader = tempRow[1];
          }
          if (tempType === "document_footer") {
            documentFooter = tempRow[1];
          }
          if (tempType === "document_owner") {
            documentOwner = tempRow[1]?.toLowerCase();
          }
          if (tempType === "document_background") {
            documentBackground = tempRow[1];
          }
          if (tempType === "document_parameters") {
            userParameters = getJsonFromCompression(tempRow[1]);
          }
          if (tempType.includes("view_") && !tempType.includes("_header")) {
            let infoValue = tempRow[1] + tempRow[2] + tempRow[3];
            if (tempRow[4]) infoValue = infoValue + tempRow[4];
            if (tempRow[5]) infoValue = infoValue + tempRow[5];
            if (tempRow[6]) infoValue = infoValue + tempRow[6];
            const viewInfo = getJsonFromCompression(infoValue);

            views.push({
              elementId: tempType,
              // elementType: viewInfo.baseElementType ?? "table",
              id: tempType,
              name: viewInfo.caption,
              fulltext: "view, " + viewInfo.caption,
              type: "view",
              viewInfo: viewInfo
            })
          }
          if (tempType.includes("range_") && !tempType.includes("_header")) {
            let infoValue = tempRow[1] + tempRow[2] + tempRow[3];
            if (tempRow[4]) infoValue = infoValue + tempRow[4];
            if (tempRow[5]) infoValue = infoValue + tempRow[5];
            if (tempRow[6]) infoValue = infoValue + tempRow[6];

            const rangeInfo = getJsonFromCompression(infoValue);
            ranges.push({
              elementId: tempType,
              id: tempType,
              name: rangeInfo.caption,
              fulltext: "range, " + rangeInfo.caption,
              type: "range",
              topImageUrl: rangeInfo.topImageUrl,
              areaInfo: rangeInfo
            })
          }
          if (tempType.includes("calculation_") && !tempType.includes("_header")) {
            let infoValue = tempRow[1] + tempRow[2] + tempRow[3];
            if (tempRow[4]) infoValue = infoValue + tempRow[4];
            if (tempRow[5]) infoValue = infoValue + tempRow[5];
            if (tempRow[6]) infoValue = infoValue + tempRow[6];

            // const infoSize = getSizeInBytes(infoValue);
            try {
              const calculationInfo = getJsonFromCompression(infoValue);
              calculations.push({
                elementId: tempType, //viewInfo.baseElementId,
                id: tempType,
                name: calculationInfo.caption,
                fulltext: "calculation, " + calculationInfo.caption,
                type: "calculation",
                topImageUrl: calculationInfo.topImageUrl,
                viewInfo: calculationInfo
              })
            } catch (err) {
              console.log("ERROR calculationInfo getJsonFromCompression", err);
            }
          }
        })
        // is owner
        if (isEmailAddress(documentOwner)) {
          if (!isSameText(documentOwner, store.main.userMe?.mail)) {
            userRoles = ["user"];
          }
        }
      } catch (err) { 
        console.log("ERROR get appInfoTable", err);
      }
    }

    // get the LOG records count
    try {
      const appLogsRange = batchRes.responses[batchRes.responses.findIndex((x) => x.id === "LOGRANGE")];
      if (appLogsRange?.body) {
        const logRowCount = appLogsRange.body.rowCount;
        if (logRowCount > 0) { changesCount = logRowCount - 1; }
      }
    } catch (err) { 
      console.log("ERROR get appLogTable", err);
    }
  }

  return { 
    views,
    ranges,
    calculations,
    changesCount,
    documentHeader,
    documentFooter,
    documentOwner,
    documentBackground,
    userParameters,
    userRoles
  };
}

